import React from 'react'
import { Container } from "semantic-ui-react";
import {CommonText} from "../../../components";
import {FacilitiesEvolutionProvider} from "./context";
import Chart from "./sections/Chart";
import Filters from "./sections/filters";

const FacilitiesEvolutionContainer = () => {
  return (
    <Container fluid className="mt-4">
      <CommonText mode="h2"> Evolución de instalaciones </CommonText>
      <FacilitiesEvolutionProvider>
        <Filters />
        <Chart />
      </FacilitiesEvolutionProvider>
    </Container>
  )
}
export default FacilitiesEvolutionContainer;
